import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor() {}

  showSuccess(title: string, message: string): void {
    Swal.fire({
      icon: 'success',
      title,
      text: message,
      confirmButtonColor: '#4f46e5'
    });
  }

  showError(title: string, message: string): void {
    Swal.fire({
      icon: 'error',
      title,
      text: message,
      confirmButtonColor: '#ef4444'
    });
  }

  showWarning(title: string, message: string): void {
    Swal.fire({
      icon: 'warning',
      title,
      text: message,
      confirmButtonColor: '#f59e0b'
    });
  }

  handleApiError(error: any, customTitle: string = 'Error de API'): void {
    console.error(`[API Error] ${customTitle}:`, error);
    let errorMsg = 'Ocurrió un inconveniente al comunicarse con la API del servidor.';

    if (error) {
      if (typeof error === 'string') {
        errorMsg = error;
      } else if (error.error && typeof error.error === 'object' && error.error.message) {
        errorMsg = error.error.message;
      } else if (error.error && typeof error.error === 'string') {
        errorMsg = error.error;
      } else if (error.message) {
        errorMsg = error.message;
      } else if (error.status === 404) {
        errorMsg = 'El servicio solicitado no está disponible (404 Not Found).';
      } else if (error.status === 401 || error.status === 403) {
        errorMsg = 'Sesión no válida o expirada. Por favor vuelve a iniciar sesión.';
      } else if (error.status === 500) {
        errorMsg = 'Error interno en el servidor (500).';
      } else if (error.status === 0) {
        errorMsg = 'No hay conexión con el servidor API. Verifica tu red.';
      }
    }

    this.showError(customTitle, errorMsg);
  }
}
